<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-member-invite v-if="showModal === 'invite'" />
        </transition>

        <v-page-header title="Getting Started" icon="fas fa-plug" />

        <v-page-filters>
            <v-button v-if="$route.name.startsWith('install-')" size="sm" btn-style="white" @click.native="$router.push({ name: 'install' })">Back</v-button>
            <v-button-toolbar>
                <v-button size="sm" btn-style="white" @click.native="invite">Invite a Teammate</v-button>
                <v-button size="sm" btn-style="primary" @click.native="docs">
                    <span>Documentation</span>
                    <i class="fas fa-external-link-alt ml-5"></i>
                </v-button>
            </v-button-toolbar>
        </v-page-filters>

        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

    </v-page>

</template>

<script>

import ModalMemberInvite from '@modals/member/ModalMemberInvite';

export default {

    components: {
        'v-modal-member-invite': ModalMemberInvite,
    },

    methods: {

        invite() {
            this.$store.commit('showModal', 'invite');
        },

        docs() {
            window.open('https://docs.crowdpower.io', '_blank');
        },

    },

}

</script>